<template>
  <div class="news">
    <div class="row">
      <div class="columns small-12">
        <h1 class="display-h3">Aktualności</h1>
      </div>
    </div>
    <div class="row">
      <div class="article columns small-12 medium-6 large-4" v-for="article in articles" :key="article.id">
        <router-link :to="`aktualnosc/${article.slug}`">
          <img v-lazyload class="article__image" v-if="article._embedded['wp:featuredmedia']" :data-src="getThumbnailImage(article)" :alt="article._embedded['wp:featuredmedia'][0].alt_text">
          <span class="article__headline">{{ article.title.rendered }}</span>
        </router-link>
      </div>
    </div>
    <div class="row" v-if="total > 1">
      <div class="columns small-12">
        <Pagination :total="total" :current="parseInt(current, 10)" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Pagination from '@/components/partials/Pagination';
import { HTTP } from '@/utils/http-common';
import { dealWithHttpErrors } from '@/mixins/deal-with-http-errors';

export default Vue.extend({
  mixins: [
    dealWithHttpErrors,
  ],
  data() {
    return {
      articles: [],
      total: 0,
    };
  },
  computed: {
    current() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    current: {
      handler: 'loadPostsByPage',
      immediate: true,
    },
  },
  methods: {
    getThumbnailImage(post) {
      return post._embedded['wp:featuredmedia'][0].media_details.sizes.rckik ? post._embedded['wp:featuredmedia'][0].media_details.sizes.rckik.source_url : post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url;
    },
    loadPostsByPage() {
      const page = this.current;
      HTTP.get('wp/v2/posts?_embed&per_page=6&categories=3&page=' + page).then((response) => {
        this.articles = response.data;
        this.total = parseInt(response.headers['x-wp-totalpages'], 10);
      }).catch((e) => {
        this.handleError(e.response);
      });
    },
  },
  components: {
    Pagination,
  },
});
</script>

<style lang="scss" scoped>
.news {
  h1 {
    margin-bottom: 60px;
  }
  .article {
    margin-bottom: 30px;
    &__image {
      margin-bottom: 30px;
      object-fit: contain;
      object-position: center;
      min-height: 350px;
    }
    &__headline {
      font-size: em(18px);
      line-height: 27px;
      font-weight: 600;
      width: 100%;
      display: block;
    }
    a {
      text-decoration: none;
    }
  }
}
</style>
